module.exports = __webpack_public_path__ + "static/media/transactions-empty.4313fe57.svg";